import React from 'react';

const Checklist = () => {
  return (
    <svg
      className="fill-current"
      width="24"
      height="24"
      viewBox="0 0 22 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.5668 4.86739H0.034668V6.95609H12.5668V4.86739ZM12.5668 0.690002H0.034668V2.7787H12.5668V0.690002ZM0.034668 11.1335H8.38945V9.04479H0.034668V11.1335ZM20.3995 6.43392L21.966 8.00044L14.666 15.3109L9.95597 10.6113L11.5225 9.04479L14.666 12.1778L20.3995 6.43392Z" />
    </svg>
  );
};

export default Checklist;
